import { AuthContext } from '@contexts/AuthContext';
import { Button, Card, CardMedia, FormControlLabel, Grid, makeStyles } from '@material-ui/core';
import { UnidadeSalvarPainel, UnidadeSalvarPainelProp, UnidadeViewModel } from '@models/Unidade';
import { MudarFotoUnidade, SalvarPainel } from '@services';
import React, { createRef, useContext, useEffect, useState } from 'react';
import { ContainerForm, ContainerFoto } from './styles';
import * as Yup from "yup";
import { Field, Formik, Form } from "formik";
import { TextField } from "formik-material-ui";
import LinearProgress from "@material-ui/core/LinearProgress";
import Checkbox from '@material-ui/core/Checkbox';
import { UnidadePageContext } from '@pages/UnidadePage/UnidadePageContext';


// import { Container } from './styles';
const useStyles = makeStyles({
    root: {
        maxWidth: 345,
    },
    media: {
        width: 260,
        height: 150
    },
    card: {
        // margin:'10px',
        padding: '10px',
        cursor: 'pointer'
    },
});
function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min);
}
const formSchema = Yup.object().shape({
    login: Yup.string().required(`Campo obrigatório`),
    senha: Yup.string().required(`Campo obrigatório`)
});
const UnidadeEditar = ({ unidadeCurrent }: { unidadeCurrent: UnidadeViewModel }) => {
    const [urlImage, setUrlImage] = useState<string>();
    const authContext = useContext(AuthContext)
    const unidadeContext = useContext(UnidadePageContext);
    const classes = useStyles();

    useEffect(() => {
        setUrlImage(getUrl())
    }, [unidadeCurrent])

    function getUrl() {
        var url = `https://storage.googleapis.com/inforcfc_store/logo_unidade/${unidadeCurrent.id}.jpg?r=${randomIntFromInterval(999, 999999)}`;
        return url;
    }
    const fileUpload = createRef<HTMLInputElement>();

    const onFileChange = async event => {
        let file = event.target.files[0];
        if (!file) return;


        try {

            console.log(file);
            const str = await MudarFotoUnidade(unidadeCurrent.id, file);
            if (str) {
                authContext.showAlert('error', str, 'Erro Google Cloud');
            } else {
                authContext.showAlert('success', 'Logo alterado com sucesso!', 'Logo');
                setTimeout(() => {
                    setUrlImage(getUrl())
                }, 500);
            }
        } catch (error:any) {
            authContext.showAlert('error', error, 'Erro Api');
        } finally {
            event.target.value = null;
        }

    };
    async function submit(values, setSubmitting) {


        let modificacoes: UnidadeSalvarPainelProp[] = []

        Object.keys(values).forEach(x => {
            if (values[x] == unidadeCurrent[x]) return;

            modificacoes.push({ prop: x, old: unidadeCurrent[x], new: values[x] })
        })

        if (!modificacoes.length) {
            authContext.showAlert('warning', 'Sem mudanças', 'Alteração');
            setSubmitting(false)
            return;
        }
        console.log(modificacoes)
        try {
            await SalvarPainel({ props: modificacoes, unidade: values })
            authContext.showAlert('success', 'Alterado com sucesso!', 'Alteração');
            if (!unidadeContext.model) return;
            let index = unidadeContext.model?.unidades.findIndex(x => x.id == values.id);
            unidadeContext.model.unidades[index] = values;
            unidadeContext.setModel({ ...unidadeContext.model })

        } catch (error) {
            authContext.showAlert('error', 'Erro ao salvar', 'Erro');
            console.log(error);

        } finally {
            setSubmitting(false)
        }


    }
    return <>
        <ContainerFoto>
            <Card className={classes.card} variant="elevation" elevation={4} onClick={() => {
                fileUpload.current?.click();
            }}>
                <img src={urlImage} className={classes.media} />
                <input style={{ display: 'none' }}
                    ref={fileUpload}
                    type="file"
                    onChange={onFileChange}

                />
            </Card>
        </ContainerFoto>
        <ContainerForm>
            <Formik
                initialValues={unidadeCurrent}

                onSubmit={(values, { setSubmitting }) => {
                    submit(values, setSubmitting)

                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                    /* and other goodies */
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Field


                            component={TextField}
                            name="nome"
                            type="text"
                            label="Nome"
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            autoComplete="false"
                            size="small"
                        />

                        <Field
                            size="small"

                            component={TextField}
                            name="fraseTela"
                            type="text"
                            label="Frase Tela"
                            variant="outlined"
                            margin="normal"

                            fullWidth
                            autoComplete="false"
                        />
                        <Field
                            size="small"

                            component={TextField}
                            name="cnpj"
                            type="text"
                            label="Cnpj"
                            variant="outlined"
                            margin="normal"

                            fullWidth
                            autoComplete="false"
                        />

                        <Grid container spacing={1}>
                            <Grid item xs={10}>
                                <Field
                                    name="endereco"
                                    label="Endereço"

                                    size="small"
                                    component={TextField}
                                    type="text"
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    autoComplete="false"
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Field
                                    name="enderecoNumero"
                                    label="Nr"

                                    size="small"
                                    component={TextField}
                                    type="text"
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    autoComplete="false"
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item xs={5}>
                                <Field
                                    name="cidade"
                                    label="Cidade"

                                    size="small"
                                    component={TextField}
                                    type="text"
                                    variant="outlined"
                                    margin="normal"

                                    fullWidth
                                    autoComplete="false"
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <Field
                                    name="bairro"
                                    label="Bairro"

                                    size="small"
                                    component={TextField}
                                    type="text"
                                    variant="outlined"
                                    margin="normal"

                                    fullWidth
                                    autoComplete="false"
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Field
                                    name="uf"
                                    label="UF"

                                    size="small"
                                    component={TextField}
                                    type="text"
                                    variant="outlined"
                                    margin="normal"

                                    fullWidth
                                    autoComplete="false"
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Field
                                    name="fone"
                                    label="Telefone"

                                    size="small"
                                    component={TextField}
                                    type="text"
                                    variant="outlined"
                                    margin="normal"

                                    fullWidth
                                    autoComplete="false"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Field
                                    name="whatsTel"
                                    label="Whatsapp"

                                    size="small"
                                    component={TextField}
                                    type="text"
                                    variant="outlined"
                                    margin="normal"

                                    fullWidth
                                    autoComplete="false"
                                    helperText="Ex: 5511974614719"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControlLabel
                                    checked={values.alunoNotificacaoAula}
                                    onChange={() => setFieldValue("alunoNotificacaoAula", !values.alunoNotificacaoAula)}
                                    control={<Checkbox />}
                                    label="Notifica aluno?"


                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControlLabel
                                    name={"ddd+" + values.id}
                                    checked={values.ddd}
                                    onChange={() => setFieldValue("ddd", !values.ddd)}
                                    control={<Checkbox />}
                                    label="Usa DDD?"
                                />
                            </Grid>
                        </Grid>
                        {isSubmitting && <LinearProgress />}

                        <br />
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={isSubmitting}

                            type="submit"
                        >
                            Enviar
                        </Button>
                    </form>
                )}
            </Formik>


        </ContainerForm>
    </>;
}

export default UnidadeEditar;